<template>
    <div class="">
        <form @submit.prevent="onSubmit">
            <div class="">
                <div class="relative mt-4">
                    <input
                        type="text"
                        placeholder="Please enter the desired search term, item number, or brand name..."
                        class="!px-5 !py-3 w-full bg-grey-50 rounded-s input-text-input"
                        v-model="searchTerm"
                        @input="onInput"
                    />
                    <div
                        v-if="
                            !preventDropdownReopen &&
                            showSuggestions &&
                            suggestions.length
                        "
                        v-click-outside="hideSuggestions"
                        class="absolute bg-white shadow rounded mt-2 w-full z-40 p-4"
                    >
                        <ul class="scroll-bar max-h-80">
                            <li
                                v-for="(suggestion, index) in suggestions"
                                :key="index"
                                class="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                @click="selectSuggestion(suggestion)"
                            >
                                {{ suggestion }}
                            </li>
                        </ul>
                    </div>

                    <button
                        type="submit"
                        class="absolute right-4 top-1/2 -translate-y-1/2"
                    >
                        <i class="fas fa-search"></i>
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { vClickOutside } from "../../directives/v-click-outside";

export default {
    props: {
        modelValue: {
            type: String,
            default: "",
        },
        suggestions: {
            type: Array,
            default: () => [], // Ensure suggestions is always an array
        },
    },
    directives: {
        clickOutside: vClickOutside,
    },
    emits: ["update:modelValue", "input", "submit"],
    inject: ["overlaysSvc"],
    data() {
        return {
            showSuggestions: false,
            preventDropdownReopen: false,
            searchTerm: this.modelValue || "",
        };
    },
    watch: {
        suggestions(newSuggestions) {
            if (!this.preventDropdownReopen) {
                this.showSuggestions = newSuggestions.length > 0;
            }
        },
    },
    methods: {
        onInput(event) {
            this.preventDropdownReopen = false;

            this.$emit("input", this.searchTerm);
        },
        selectSuggestion(suggestion) {
            this.searchTerm = suggestion;
            this.showSuggestions = false;
            this.preventDropdownReopen = true; // Prevent reopening until the user types again
            this.$emit("update:modelValue", suggestion);
            this.$emit("submit", suggestion);
        },
        hideSuggestions() {
            this.showSuggestions = false;
        },
        onSubmit(event) {
            this.showSuggestions = false;
            this.preventDropdownReopen = true;
            this.$emit("update:modelValue", this.searchTerm);
            this.$emit("submit", this.searchTerm);
        },
    },
};
</script>
